import { render, staticRenderFns } from "./WorkPermitDetail.vue?vue&type=template&id=9d3177b4&scoped=true&"
import script from "./WorkPermitDetail.vue?vue&type=script&lang=js&"
export * from "./WorkPermitDetail.vue?vue&type=script&lang=js&"
import style0 from "./WorkPermitDetail.vue?vue&type=style&index=0&id=9d3177b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3177b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d3177b4')) {
      api.createRecord('9d3177b4', component.options)
    } else {
      api.reload('9d3177b4', component.options)
    }
    module.hot.accept("./WorkPermitDetail.vue?vue&type=template&id=9d3177b4&scoped=true&", function () {
      api.rerender('9d3177b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/WorkPermitDetail.vue"
export default component.exports